import { action, computed, observable } from 'mobx'
import { JtechStore } from 'src/plugins/mobx'

export default class BillingOrderModel {
    @observable filters = {};
    @observable orders = {};

    static getInstance () {
      return JtechStore.getSingleton('billingOrderModel', new BillingOrderModel())
    }

    @action.bound setFilters (filter) {
      this.filters = filter
    }

    @action.bound setOrders (orders) {
      this.orders = orders
    }
}
